module.exports = __webpack_public_path__ + "static/img/huawei-appgallery-badge-en.717ea0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huawei-appgallery-badge-en.png
// module id = vYuf
// module chunks = 1